import { Injectable } from '@angular/core';
import { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import { AdapterFindInterface } from '@zaoblako/shared/modules/traffic/dtos/adapter/adapter-find.dto';
import { AdapterPageInterface } from '@zaoblako/shared/modules/traffic/dtos/adapter/adapter-page.dto';
import { AdapterQueryInterface } from '@zaoblako/shared/modules/traffic/dtos/adapter/adapter-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrafficAdapterService extends BaseService {
  protected baseUrl = '/traffic/adapter';

  public findWithPagination(queryParams: AdapterQueryInterface): Observable<AdapterPageInterface> {
    return this.http.get<AdapterPageInterface>(this.baseUrl, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getHistory(id: number, queryParams: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restore(id: number): Observable<AdapterFindInterface> {
    return this.http.post<AdapterFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }
}
